import React, { useState, useEffect } from 'react';
import { useTr } from '../hooks/useTr';

const PuestoSelect = ({ value, onChange, error, index }) => {
    const tr = useTr();
    const [puestos, setPuestos] = useState([]);

    const selectedPuesto = value?.puesto || '';
    const otroPuesto = value?.otroPuesto || '';
    const showOtros = value?.puesto === 'Otros';

    useEffect(() => {
        const fetchPuestos = async () => {
            const response = await fetch(
                `https://api-toolsconduto.conduto.com.ec/candidatos/puestos?lang=es`
            );
            const result = await response.json();

            if (result.success) {
                setPuestos(result.data);
            }
        };

        fetchPuestos();
    }, []);

    const handleSelectPuesto = (e) => {
        const value = e.target.value;

        if (value === 'Otros') {
            onChange({ puesto: 'Otros', otroPuesto: '' });
        } else if (value === '') {
            onChange({ puesto: '', otroPuesto: '' });
        } else {
            onChange({ puesto: value, otroPuesto: null });
        }
    };

    const handleOtroPuestoChange = (e) => {
        const value = e.target.value;
        onChange({ puesto: 'Otros', otroPuesto: value });
    };

    return (
        <div>
            <div className="mb-3">
                <div className="input-group">
                    <select
                        className={`form-select ${error ? 'is-invalid' : ''}`}
                        value={selectedPuesto}
                        onChange={handleSelectPuesto}
                    >
                        <option value="">{tr('Seleccionar Puesto')}</option>
                        {puestos.map((puesto) => (
                            <option key={puesto.id} value={puesto.nombre}>
                                {tr(puesto.nombre)}
                            </option>
                        ))}
                        <option value="Otros">{tr('Otros')}</option>
                    </select>
                </div>
                {error && <div className="invalid-feedback d-block">{tr(error)}</div>}
            </div>

            {showOtros && (
                <div className="mb-3">
                    <label className="form-label">{tr('Debe especificar el puesto')} <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder={tr('Debe especificar el puesto')}
                        value={otroPuesto}
                        onChange={handleOtroPuestoChange}
                    />
                </div>
            )}
        </div>
    );
};

export default PuestoSelect;